<flx-resources-grid
  [tableDef]="notificationsTableColumns"
  [inputGridOptions]="gridOptions()"
  (gridReady)="onGridReady($event)"
  emptyMsg="No notifications"
  emptyMsgDescription="Notifications this instance sent appear here."
/>
